import authApi from '../../../services/authApi';
import logger from '../../../utils/logger';

export const userProfileService = {
  /**
   * Busca o perfil completo do usuário logado
   * @returns {Promise<Object>} Dados do perfil
   */

  async getProfile() {
    try {
      logger.log('📋 Buscando perfil do usuário...');
      const response = await authApi.get('/auth/profile');
      return response.data;
    } catch (error) {
      logger.error('❌ Erro ao buscar perfil:', error);
      throw error;
    }
  }
  
};